import { posthog } from "posthog-js"

// How long to wait for PostHog before letting login continue without it.
const FLAG_RELOAD_TIMEOUT_MS = 2000

// Resolves once PostHog has evaluated feature flags for the newly identified
// user, or after the timeout so a blocked PostHog never holds up login.
//
// Two SDK behaviours shape this. A newly added handler is called straight
// away with whatever flags are already loaded, so that first synchronous call
// is skipped. And a reload requested while another request is in flight is
// queued behind it, so the first asynchronous callback can still carry the
// anonymous flags. identify() stores the old anonymous id in
// featureFlags.$anon_distinct_id and the SDK clears it only when the reload
// that carried the new identity has completed, so that is the signal to wait
// for.
export const waitForFeatureFlags = (): Promise<void> =>
  new Promise((resolve) => {
    let registering = true

    const finish = () => {
      clearTimeout(timer)
      unsubscribe()
      resolve()
    }

    const timer = setTimeout(finish, FLAG_RELOAD_TIMEOUT_MS)

    const unsubscribe = posthog.onFeatureFlags(() => {
      const identifiedReloadDone =
        posthog.featureFlags.$anon_distinct_id === undefined
      if (!registering && identifiedReloadDone) {
        finish()
      }
    })

    registering = false
  })
